import { useLookbookNavigationSettingsContext } from '@app/components/lookbook/LookbookSettingsPage/contexts';
import { getIsFolderNavigationItem } from '@app/logic/lookbook';
import { useLookbookDetails } from '@app/services/hooks/lookbook/useLookbookDetails';
import { isDefined } from '@app/utils/is';
import React from 'react';

import { AddedNavigationItems } from './AddedNavigationItems/AddedNavigationItems';
import { AvailableNavigationItems } from './AvailableNavigationItems/AvailableNavigationItems';

interface Props {
  lookbookId?: string;
}

export const LookbookSettingsNavigationMenu = ({ lookbookId }: Props) => {
  const { setNavigationItems } = useLookbookNavigationSettingsContext();
  const { isLoading, data } = useLookbookDetails({ lookbookId });

  const navigationItems = React.useMemo(() => {
    return data?.navigationItems ?? [];
  }, [data?.navigationItems]);

  const navigationItemsWithIds = React.useMemo(
    () =>
      navigationItems.map(parentItem => {
        const { children, id: parentId } = parentItem;

        const childrenWithParentId = children?.map(child => ({
          ...child,
        }));

        const childrenToReturn = isDefined(childrenWithParentId) ? { children: childrenWithParentId } : {};

        if (getIsFolderNavigationItem(parentItem)) {
          return {
            ...parentItem,
            ...childrenToReturn,
            id: parentId,
          };
        }

        return {
          ...parentItem,
          ...childrenToReturn,
          id: parentId,
        };
      }),
    [navigationItems],
  );

  React.useEffect(() => {
    setNavigationItems(navigationItemsWithIds);
  }, [setNavigationItems, navigationItemsWithIds]);

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <AvailableNavigationItems isLoading={isLoading} />
      <AddedNavigationItems isLoading={isLoading} />
    </div>
  );
};
